import React, { useEffect, useState } from 'react';
import { servicios } from '../../json/servicios';
import './servicios.css';  // Cambia la importación del CSS


const Servicios = () => {
    const [isVisible, setIsVisible] = useState(false); // 
    useEffect(() => {
        window.scrollTo(0, 0);
        setTimeout(() => setIsVisible(true), 100); // Activa la visibilidad después de cargar
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Servicios</h3> {/* Título modificado */}
                    <hr className='hr-gob'/>
                </div>
                {
                    servicios.map((item, index) => (
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_historicos'>
                                <div className='card_anio'>
                                    <h5>{ item.anio }</h5>
                                    <h6>{ item.descripcion }</h6>
                                    {
                                        item.trimestres.map((trim, index) => (
                                            <div key={ index } className='card_trimestre'>
                                                <p>
                                                    { trim.trimestre } 
                                                    <span className="badge bg-secondary">
                                                        <a href={ trim.urlCnartys } target="_blank" rel="noopener noreferrer">CNARTyS</a>
                                                    </span>
                                                    
                                                    <span className="badge bg-secondary">
                                                        <a href={ trim.urlRuts } target="_blank" rel="noopener noreferrer">RUTS</a>
                                                    </span>
                                                </p><br /> 
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Servicios; // Asegúrate de exportar con el nuevo nombre
